export default __webpack_public_path__ + "static/b2-be3c79360d337571e87e34dda5310539.png";